import { RestMethod } from '../../_helpers/ApiConfig/RestMethod'
import FilterResponse from '../../_helpers/FilterResponse'
import toastr from 'toastr'

export const ServiceRequestServices = {
    addServiceRequest,
    getAllWarehouseList,
    getAllServiceList,
    postComment,
    getComment,
    getAllOwnerWarehouseList,
    serviceRequestList,
    updateServiceRequestStatus,
    addUpdateServiceRequest,
    getServiceRequestData,
    serviceRequestMapForm,
    getAllWarehouseForserviceRequest
}

/**
 * 
 * @Pankaj
 * For adding service request
 */
async function addServiceRequest(data) {
    try {
        const response = await RestMethod.POST('/service-request', data);
        if (response.data.status_code === 200) {
            toastr.info("Submitted Successfully")
        }
        return FilterResponse(response); //If respone 200 to 299 Then return 
    }
    catch (error) {
        if (error && error.status !== 420) { toastr.error('Something Went Wrong') }
        console.log("error detected while fetching data from api");
        return null;
    }
}

/**
 * 
 * @Pankaj
 * Getting All Warehouse
 */
async function getAllWarehouseList() {

    try {
        const response = await RestMethod.GET('/my-booking');
        return FilterResponse(response); //If respone 200 to 299 Then return 
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getAllWarehouseForserviceRequest() {

    try {
        const response = await RestMethod.GET('/booking-for-service-request');
        return FilterResponse(response); //If respone 200 to 299 Then return 
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}


async function getAllOwnerWarehouseList() {

    try {
        const response = await RestMethod.GET('/warehouse-owner-service');
        return FilterResponse(response); //If respone 200 to 299 Then return 
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

/**
 * 
 * @Vishal
 * Getting All Service List
 */
async function getAllServiceList() {

    try {
        const response = await RestMethod.GET('/all-service-request');
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}


async function postComment(data) {
    try {
        const response = await RestMethod.POST('/service-request-comment', data);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getComment(id) {
    try {
        const response = await RestMethod.GET('/all-comment/' + id);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}


async function serviceRequestList(offset, limit, queryString) {
    var reuestlink = "/all-service-request-list";
    //+ queryString
    if (offset !== null && limit !== null) {
        reuestlink = reuestlink + "?limit=" + limit + "&offset=" + offset;
    }
    try {
        const response = await RestMethod.GET(reuestlink);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function updateServiceRequestStatus(data, id) {
    try {
        let url = 'service-request-list-status/' + id
        const response = await RestMethod.PUT(url, data);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        return null;
    }
}

async function addUpdateServiceRequest(data) {
    try {
        let url = '/add-update-service-request'
        const response = await RestMethod.POST(url, data);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        return null;
    }
}

async function getServiceRequestData(id) {
    try {
        const response = await RestMethod.GET('/service-request-detail/' + id);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function serviceRequestMapForm(data) {
    try {
        const response = await RestMethod.POST('/service-request-form-map', data);
        const api_response = FilterResponse(response); //If respone 200 to 299 Then return 
        return api_response.data;
    }
    catch (error) {
        toastr.error('Something Went Wrong')
        console.log("error detected while fetching data from api");
        return null;
    }
}